"use client"

import type { PropsWithChildren } from "react"
import clsx from "clsx"

import InlineCta from "~/components/ui/InlineCta"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { usePanel } from "~/managers/PanelManager"

import { sprinkles, type Sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

export function PanelSizeChartTrigger(props: PropsWithChildren<{ sprinklesCss?: Sprinkles }>) {
  const { add } = usePanel()
  const t = useTranslate()

  return (
    <InlineCta
      onClick={() => add(<>{props?.children}</>)}
      customLineActive={true}
      weight="semiBold"
      fontFamily="spezia"
      transform="uppercase"
      className={clsx(
        css.PanelSizeChartTrigger,
        sprinkles({ letterSpacing: 0.4, lineHeight: 1, ...(props?.sprinklesCss ?? {}) })
      )}
    >
      {t("size_chart_trigger")}
    </InlineCta>
  )
}
